import { Component, h, Host, Prop } from '@stencil/core';
import { VdsContentBaseProperties } from '../vds-content-base/vds-content-base.interface';

@Component({
  tag: 'vds-content-image-carpet',
  styleUrl: 'vds-content-image-carpet.scss',
  shadow: true,
})
export class VdsContentImageCarpet implements VdsContentBaseProperties {
  /**
   * Headline for the Content Modules
   * Mandatory: no
   * Max Chars: 50
   */
  @Prop() headline = '';

  /**
   * Subline for the Content Module
   * Mandatory: no
   * Max Chars: 150
   */
  @Prop() subline = '';

  /**
   * Controls wether or not the downloads should be displayed
   */
  @Prop() showDownloads = false;

  /**
   * Sets the layout of the image gallery
   */
  @Prop() galleryType: 'two' | 'three-left' | 'three-right' | 'four' = 'three-left';

  /**
   * Caption for Gallery displayed underneath
   */
  @Prop() galleryCaption: string;

  /**
    * Image Copyright
    * displayed underneath the caption
    */
  @Prop() copyright: string;

  render() {
    const { headline, subline, showDownloads, galleryType, galleryCaption, copyright } = this;

    return (
      <Host>
        <vds-content-base
          headline={headline}
          subline={subline}
          show-downloads={showDownloads}
          >

          <div slot="copy-above">
            <slot name="copy-above"></slot>
          </div>

          <figure slot="media">
          { this.renderGallery(galleryType) }
          <figcaption class="text-sm text-grey-light mt-2">
            { galleryCaption }
            <br />
            { copyright }
          </figcaption>
          </figure>

          <div slot="copy-below">
            <slot name="copy-below"></slot>
          </div>

          { showDownloads && (
            <div slot="downloads">
              <slot name="downloads"></slot>
            </div>
          )}
        </vds-content-base>
      </Host>
    );
  }

  renderGallery(type: 'two' | 'three-left' | 'three-right' | 'four'): string {
    switch (type) {
      case 'two':
        return (
          <div class="grid grid-rows-1 grid-cols-1 md:grid-cols-2 gap-[1px]" gallery-type={this.galleryType}>
            <div class="col-span-1 rounded-l">
              <slot name="image-one"></slot>
            </div>
            <div class="col-span-1 rounded-r">
              <slot name="image-two"></slot>
            </div>
          </div>
        );
      default:
      case 'three-left':
        return (
          <div class="grid grid-rows-1 grid-cols-1 md:grid-rows-2 md:grid-cols-3 gap-[1px]" gallery-type={this.galleryType}>
            <div class="col-span-1 md:col-span-2 md:row-span-2 rounded-l">
              <slot name="image-one"></slot>
            </div>
            <div class="col-span-1 md:row-span-1 rounded-tr">
              <slot name="image-two"></slot>
            </div>
            <div class="col-span-1 md:row-span-1 rounded-br">
              <slot name="image-three"></slot>
            </div>
          </div>
        );
      case 'three-right':
        return (
          <div class="grid grid-rows-1 grid-cols-1 md:grid-rows-2 md:grid-cols-3 gap-[1px]" gallery-type={this.galleryType}>
            <div class="col-span-1 md:row-span-1 rounded-tl">
              <slot name="image-one"></slot>
            </div>
            <div class="col-span-1 md:col-span-2 md:row-span-2 rounded-r">
              <slot name="image-two"></slot>
            </div>
            <div class="col-span-1 md:row-span-1 rounded-bl">
              <slot name="image-three"></slot>
            </div>
          </div>
        );
      case 'four':
          return (
            <div class="grid grid-rows-1 grid-cols-1 md:grid-rows-2 md:grid-cols-2 gap-[1px]" gallery-type={this.galleryType}>
              <div class="col-span-1 md:row-span-1 rounded-tl">
                <slot name="image-one"></slot>
              </div>
              <div class="col-span-1 md:row-span-1 rounded-tr">
                <slot name="image-two"></slot>
              </div>
              <div class="col-span-1 md:row-span-1 rounded-bl">
                <slot name="image-three"></slot>
              </div>
              <div class="col-span-1 md:row-span-1 rounded-br">
                <slot name="image-four"></slot>
              </div>
            </div>
          );
    }
  }
}
